// The ladder inactivity rule's "play by" note (13 Oct 2026). The API puts the
// date on each team row (inactivityPlayBy): when that team drops unless it has
// an approved match by then. A freeze pauses it, so a frozen team has none.
// Wording and the red threshold match the app (ladder_hero_copy.dart).

const places = (ladder) => {
    const n = ladder?.inactivityDemotionPlaces ?? 0;
    return n > 0 ? `or drop ${n} place${n === 1 ? '' : 's'}` : 'to keep your place';
};

/** "Play by Tue 3 Nov or drop 2 places"; null when the rule does not apply to this team. */
export function playByLine(ladder, team, now = new Date()) {
    if (!ladder?.inactivityDemotionEnabled || !team?.inactivityPlayBy) return null;
    const by = new Date(team.inactivityPlayBy);
    if (Number.isNaN(by.getTime())) return null;
    if (by <= now) return `Play now ${places(ladder)}`;
    const options = {weekday: 'short', day: 'numeric', month: 'short'};
    if (by.getFullYear() !== now.getFullYear()) options.year = 'numeric';
    const date = new Intl.DateTimeFormat('en-GB', options).format(by).replace(',', '');
    return `Play by ${date} ${places(ladder)}`;
}

/** Red once half the period or less is left. */
export function playByUrgent(ladder, team, now = new Date()) {
    const days = ladder?.inactivityDemotionDays;
    if (!team?.inactivityPlayBy || !days || days <= 0) return false;
    const by = new Date(team.inactivityPlayBy);
    if (Number.isNaN(by.getTime())) return false;
    return by.getTime() - now.getTime() <= days * 12 * 60 * 60 * 1000;
}

/** The sentence under the line, saying what the rule is. */
export function playByHint(ladder) {
    const days = ladder?.inactivityDemotionDays;
    if (!days) return null;
    return `This ladder moves down anyone who goes ${days} days without an approved match. You are warned first.`;
}
